import { Chip } from '@mui/material';

import { cashLogStatusLabel } from '@/helpers/cashLogs';

import type { CashLogStatus as Status } from '@/types/machine';

const COLOR: Record<
  Status,
  'warning' | 'success' | 'error' | 'info' | 'primary' | 'secondary' | 'default'
> = {
  provisional: 'warning',
  confirmed: 'success',
  invalidated: 'error',
  deposited: 'info',
  deposited_over: 'primary',
  deposited_under: 'secondary',
  voided: 'default',
};

/**
 * Status chip for cash-log tables. Renders the native Bitstop/MUI `Chip` so the
 * list matches the detail-page treatment (amber / green / red).
 */
const CashLogStatus = ({ value }: { value: Status }) => (
  <Chip
    size="small"
    color={COLOR[value] ?? 'default'}
    label={cashLogStatusLabel(value)}
    sx={{ textTransform: 'capitalize' }}
  />
);

export default CashLogStatus;
